import { CustomError } from "./custom-error";

export class FinnAutoFailedError extends CustomError {
  constructor() {
    super('Fehlgeschlagen! Bitte versuchen sie es erneut.')

    Object.setPrototypeOf(this, FinnAutoFailedError.prototype);
  }
}
